var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.561,
    height: 18.945
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.382.25H1.179a.927.927 0 00-.929.929h0v16.587a.927.927 0 00.929.929h27.2a.927.927 0 00.929-.929h0V1.179a.949.949 0 00-.926-.929zM1.411 2.008l13.039 9.919a.55.55 0 00.7 0l12.967-9.919v15.493H1.411zm13.369 8.725L2.539 1.411h24.45z",
    fill: "#555",
    stroke: "#555",
    strokeWidth: 0.5
  })));
}

export default __webpack_public_path__ + "static/media/email_sm.466a7ca6daa5dd5ad0a62a9d9e511343.svg";
export { SvgEmailSm as ReactComponent };